import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../../common/input';
import CancelButtonLink from '../../../common/buttons/cancelButtonLink';
import AdminSaveButton from '../../shared/Buttons/AdminSaveButton';
import AdminDeleteButton from '../../shared/Buttons/AdminDeleteButton';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import Tooltip from '../../../common/tooltip';

const Form = ({
  handleSubmit,
  pristine,
  submitting,
  valid,
  onDelete,
  initialValues,
}) => (
  <form onSubmit={handleSubmit}>
    <fieldset disabled={submitting}>
      <div className="layout">
        <div className="layout__item">
          <span className="c-label-new">Name</span>
          <Input
            className="c-input"
            name="name"
            type="text"
            placeholder="Plan name"
          />
        </div>
      </div>
      <div className="layout u-mt">
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="extraFeatures"
            id="extraFeatures"
            label="Extra Features"
            wrapperClass="u-inline-block"
          />
          <Tooltip>
            Includes Loyalty Program and Waiting List when shop subscribes to this plan
          </Tooltip>
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="customApp"
            id="customApp"
            label="Custom App"
            wrapperClass="u-inline-block"
          />
          <Tooltip>Includes Custom App when shop subscribes to this plan</Tooltip>
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="campaignsEnabled"
            id="campaignsEnabled"
            label="Engage"
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="commissionReportingEnabled"
            id="commissionReportingEnabled"
            label="Commission Reports"
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="productReportingEnabled"
            id="productReportingEnabled"
            label="Product Reports"
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="customReportingEnabled"
            id="customReportingEnabled"
            label="Custom Reports Enterprise"
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="chatEnabled"
            id="chatEnabled"
            label="Chat"
            wrapperClass="u-inline-block"
          />
        </div>
        <div className="layout__item u-1/2">
          <CheckboxSwitch
            name="conversionTracking"
            id="conversionTracking"
            label="Conversion Tracking"
            wrapperClass="u-inline-block"
          />
        </div>
      </div>
      <div display-if={initialValues.id} className="c-heading c-heading--small c-heading--dark u-mt">
        Active subscriptions: <strong>{initialValues.activeSubscriptionsCount}</strong>
      </div>
      <div className="c-separator u-mt" />
      <div className="u-mt-">
        <small display-if={initialValues.id && initialValues.activeSubscriptionsCount > 0}>
          Cannot delete plan that has active subscriptions.
        </small>
      </div>
      <div className="u-text-right">
        <AdminDeleteButton
          className="c-btn c-btn--red u-width-120 u-mr- u-float-left"
          onClick={onDelete}
          display-if={onDelete}
          disabled={initialValues.id && initialValues.activeSubscriptionsCount > 0}
          title="Cannot delete"
        />
        <CancelButtonLink link="/admin/subscription/plans" content="Cancel" />
        <AdminSaveButton disabled={pristine || !valid} content="Save" />
      </div>
    </fieldset>
  </form>
);
Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  initialValues: PropTypes.object.isRequired,
};
Form.defaultProps = {
  onDelete: null,
};

export default Form;
